import {
  BpkButtonV2,
  BUTTON_TYPES,
} from '@skyscanner/backpack-web/bpk-component-button';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import type { TextStyle } from '@skyscanner/backpack-web/bpk-component-text/src/BpkText';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import { withI18n } from '../../contexts/i18n';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './LegalDisclaimerLinkButton.module.scss';

const cls = cssModules(STYLES);

const LegalDisclaimerLinkButton = ({
  className,
  i18n,
  inlineStyle = false,
  isMobileBanner = false,
  textStyle = TEXT_STYLES.bodyDefault,
}: {
  i18n: I18nService;
  inlineStyle?: boolean;
  isMobileBanner?: boolean;
  className?: string;
  textStyle?: TextStyle;
}) => {
  const searchResultsBanner = isMobileBanner
    ? i18n.translate('SearchResults_link_aboutLearnMore')
    : i18n.translate('SearchResults_hops_legal_disclaimer_howSkyscannerWorks');
  return (
    <BpkButtonV2
      type={BUTTON_TYPES.link}
      className={cls(
        'LegalDisclaimerLinkButton',
        inlineStyle && 'LegalDisclaimerLinkButton__inline',
        className,
      )}
      blank
      href="https://www.skyscanner.net/media/regulation-2019-1150-platform-to-business-regulation"
    >
      <BpkText textStyle={textStyle}>
        {inlineStyle
          ? searchResultsBanner
          : i18n.translate(
              'DetailsPage_hops_legal_disclaimer_featured_price_title',
            )}
      </BpkText>
    </BpkButtonV2>
  );
};

export default withI18n(LegalDisclaimerLinkButton);
